export interface IDataState {
  loading: boolean
  saving: boolean | null
  removing: boolean | null
  finished: boolean | string | null
  errors: any
  dialog: boolean | null
  none: boolean | null
  clone: any
  saved: boolean
  to: any
  message: string
  title: string
  button: string
  controller: { [id: string]: AbortController | null } | null
  scrollHeight: number | null
  offsetHeight: number | null
  scrollTop: number | null
  checkin: boolean
  withdraw: boolean
}

export const state = (props?: Partial<IDataState>): IDataState => ({
  loading: false,
  saving: false,
  removing: false,
  finished: false,
  errors: {},
  dialog: false,
  none: false,
  clone: null,
  saved: false,
  to: null,
  message: '変更内容が保存されていません。変更を保存しますか？',
  title: '変更の確認',
  button: '保存する',
  controller: null,
  scrollHeight: null,
  offsetHeight: null,
  scrollTop: null,
  checkin: false,
  withdraw: false,
  ...props
})

export default state
